import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'app-button-cell-viewer',
  templateUrl: './button-cell-viewer.component.html',
  styleUrls: ['./button-cell-viewer.component.scss']
})
export class ButtonCellViewerComponent implements OnInit {

  item: any;
  fieldDefinition: FieldDefinition;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {

  }

  onSelectActionType() {
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
    };
    this.valueChanged.emit(payload);
  }

}
